import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-popup',
  templateUrl: './special-offer-popup.component.html',
  styleUrls: ['./special-offer-popup.component.scss'],
  standalone: false,
})
export class SpecialOfferPopupComponent {
  @Input() title: string = 'common.defaultModal.infoTitle';
  @Input() description: string = 'defaultModal.description';
  @Input() successButton: string = 'common.closeButton';

  constructor(private _activeModal: NgbActiveModal) {}

  buttonClicked(value: boolean) {
    this._activeModal.close(value);
  }
}
